import {
  IModClear,
  IModColorBgText,
  IModFirstLetterUppercase,
} from '@ucheba/utils/helpers/styles/mod.types'
import {
  IPropChildren,
  IPropCss,
  IPropOnClick,
} from '@ucheba/utils/helpers/components/prop.types'

export interface IChipsProps
  extends IPropChildren,
    IPropOnClick,
    IModColorBgText,
    IModClear,
    IPropCss,
    IModFirstLetterUppercase,
    IChipsVariantProps {}

export interface IChipsVariantProps {
  variant?: keyof typeof EChipsVariant
}

export enum EModChipsVariant {
  default = 'variant=default',
  outline = 'variant=outline',
}

export enum EChipsVariant {
  default = 'default',
  outline = 'outline',
}

export interface IUseChipsCore {
  (props: { onClick: IPropOnClick['onClick'] }): {
    rendering: boolean
    onClear: IPropOnClick['onClick']
  }
}
